class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');

    //openpopupInsideDrawer();
   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  
  renderContents(parsedState) {
    if (parsedState?.id) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      // Added all update functions here to run once
      checkAndRemoveItems();
      checkAndRemoveFreebies();
      checkCartTotal();
      checkCartProducts();
      loadTogglestate();
      wishlistRender();
      fetchCartItemsCount();
      setTimeout(() => {
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    } else {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          document.querySelector('.drawer').classList.remove('is-empty');
          document.querySelector('#CartDrawer').innerHTML = html.querySelector('#CartDrawer').innerHTML;
        }).finally(() => {
          // Added all update functions here to run once after the fetch completes
          checkAndRemoveItems();
          checkAndRemoveFreebies();
          checkCartTotal();
          checkCartProducts();
          loadTogglestate();
          wishlistRender();
          fetchCartItemsCount();
          setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
          });
        });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      // {
      //   id: 'cart-icon-bubble'
      // }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      // {
      //   id: 'cart-icon-bubble',
      //   section: 'cart-icon-bubble',
      //   selector: '.shopify-section'
      // }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// NEW FUNCTION for element counting and adaptation to recharge
function fetchCartItemsCount(bundleHandler = false) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => response.json())
    .then((cart) => {
      const uniqueItems = {};

      cart.items.forEach((item) => {
        if (item.properties && item.properties._rc_bundle) {
          const bundleId = item.properties._rc_bundle;

          if (!uniqueItems[bundleId]) {
            uniqueItems[bundleId] = item.quantity;
          }
        } else {

          uniqueItems[item.key] = item.quantity;
        }
      });
      
      const cDW = document.querySelector('cart-drawer');
      const totalUniqueProducts = Object.keys(uniqueItems).length;
      const counterContainer = document.querySelector('.cart-count-bubble [aria-hidden="true"]');

      if (counterContainer) {
        counterContainer.textContent = `${totalUniqueProducts > 0 ? totalUniqueProducts : ""}`;
      }
      if (bundleHandler && cDW) {
        setTimeout(() => {
          cDW.classList.toggle('is-empty', totalUniqueProducts === 0);
        }, 500);
      }
    })
    .catch((error) => console.error('Error fetching cart:', error));
}
fetchCartItemsCount();
// NEW FUNCTION to adapt the removal of the entire bundle recharge
async function checkAndRemoveRechargeItems(bundleId) {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(cart => {
      const updates = cart.items.reduce((acc, item, index) => {
        if (item.properties && item.properties._rc_bundle === bundleId) {
          acc[item.key] = 0;
        }
        return acc;
      }, {});

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
    })
    .then(response => response.json())
    .then(updatedCart => {
      console.log('Updated cart:', updatedCart);
    })
    .catch(error => console.error('Error updating cart:', error));
}

/**Pop Up Script
function openpopupInsideDrawer() {
  const clickcartPU = document.getElementById("showPUcart");
  const popupcart = document.getElementById("addon-popup-cart");
  const closecartPU = document.getElementById("hidePU");
  const closecartPUx = document.getElementById("hidePUx");

  if (clickcartPU && popupcart && closecartPU && closecartPUx) {
    clickcartPU.addEventListener('click', () => {
      popupcart.style.display = 'block';
    });
    
    popupcart.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPU.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
    
    closecartPUx.addEventListener('click', () => {
      popupcart.style.display = 'none';
    });
  }
}
**/


function wishlistRender(){
  const wishlist_full = document.getElementById("wishlist-items");
  if (wishlist_full) {
    if (wishlist_full.innerHTML.trim() !== '') {
        // Wishlist is loaded, element is not empty
        //console.log('Element is not empty');
      } else {
        // Wishlist is not loaded, element is empty
        //console.log('Element is empty');
        //loading cart wishlist js
        setTimeout(() => {},1000)
        const script_1 = document.createElement('script');
        script_1.src = cart_wishlist_widget_url;
        script_1.crossOrigin = "anonymous";
        script_1.defer = true;
        document.body.appendChild(script_1);
      }
    }
  }
wishlistRender()

//Remove items from cart if Has gift and kit products
function checkAndRemoveItems() {
  loadTogglestate();
  hideVIPIfSessionStorageExists('vipatc', 'vipatcClose');
  console.log('checking products HAS!!!');
  //Removing Regular Kit when upgrade to deluxe
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        let hasGiftKitIndex = -1;
    
        cart.items.some((item, index) => {
            if (idsGiftKist.includes(item.product_id)) {
                hasGiftKitIndex = idsGiftKist.indexOf(item.product_id);
                return true;
            }
            return false;
        }); 

        if (hasGiftKitIndex !== -1) {
          let removeId = removeProductIfHasGiftKits[hasGiftKitIndex];
          let elementToRemove = document.querySelector(`cart-drawer-items .cart-item[data-productid="${removeId}"]`);
          if (elementToRemove) {
            elementToRemove.querySelector('cart-remove-button').click();
              //console.log(`Removed item with ID: ${removeId}`);
          }
        }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

//const freebieProductId = 14785127219563;
//const customerIsVIP = {% if customer and customer.tags contains 'tier: VIP' %}true{% else %}false{% endif %};
//VIP freebie logic
function checkAndRemoveFreebies() {
  if (typeof customerIsVIP === 'undefined' || typeof freebieProductId === 'undefined') {
    console.error('Error: Required variables are not defined. Please ensure they are set in your Liquid file.');
    return;
  }

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartSubtotal = cart.total_price / 100;
      const freebiesInCart = cart.items.filter(item => item.product_id === freebieProductId);
      const updates = {};
      let needsUpdate = false;

      // RULE 1: If cart total is below $99, remove ALL freebies.
      if (cartSubtotal < 99 && freebiesInCart.length > 0) {
        freebiesInCart.forEach(item => {
          updates[item.key] = 0;
        });
        needsUpdate = true;
        console.log('Cart subtotal is below $99. Removing all freebies.');
      }
      
      // RULE 2: Only check for VIP logic if the cart total is $99 or more
      else if (customerIsVIP) {
        // VIP LOGIC: If a VIP has more than two freebies, remove the extras.
        if (freebiesInCart.length > 2) {
          const itemsToRemove = freebiesInCart.slice(2);
          itemsToRemove.forEach(item => {
            updates[item.key] = 0;
          });
          needsUpdate = true;
          console.log('VIP limit exceeded. Removing extra freebies.');
        }
      } 
      
      // RULE 3: If a customer is NOT a VIP, remove ALL freebies (only if cart total is $99 or more)
      else if (!customerIsVIP && freebiesInCart.length > 0) {
          freebiesInCart.forEach(item => {
            updates[item.key] = 0;
          });
          needsUpdate = true;
          console.log('Non-VIP customer detected. Removing all freebies.');
      }

      if (needsUpdate) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then(response => response.json())
          .then(updatedCart => {
            console.log('Cart API updated with freebie changes.');
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents({ sections: { 'cart-drawer': updatedCart } });
            } else {
              window.location.reload(); 
            }
          })
          .catch(error => {
            console.error('Error removing items from cart:', error);
          });
      }
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
}


//get total price and ids cart products
function checkCartTotal() {
  return fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
   
    const totalPrice = cart.total_price / 100;

    const productLists = cart.items.map(item => item.id);

    return {
      totalPrice,
      productLists
    };
  })
  .catch(error => {
    console.error('Помилка при отриманні кошика:', error);
    return null; 
  });
}

//Kit VIP ATC close
function vipClose() {
  const vipatc = document.getElementById("vipatc");
  vipatc.style.display = "none";
  sessionStorage.setItem('vipatcClose', 'true');
}

//Kit VIP ATC storage session
function hideVIPIfSessionStorageExists(elementId, sessionStorageKey) {
  if (sessionStorage.getItem(sessionStorageKey)) {
    const vipelement = document.getElementById(elementId);
    if (vipelement) {
      vipelement.style.display = 'none';
    }
  }
}
hideVIPIfSessionStorageExists('vipatc', 'vipatcClose');

//Loading VIP toggle State
function loadTogglestate () {
  const vipCheckbox = document.getElementById('perk_cart_toggle');
  const checkboxKey = 'myCheckboxState';
  if (vipCheckbox) {
    // On page load, retrieve the checkbox state from session storage
    window.addEventListener('load', () => {
      const storedState = sessionStorage.getItem(checkboxKey);
      if (storedState) {
        vipCheckbox.checked = JSON.parse(storedState);
        if (vipCheckbox.checked) {
          //console.log("Checkbox true");
          const checkoutButton = document.getElementById('CartDrawer-Checkout');
          const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');
          checkoutButton.classList.add('checkout_hide');
          vipcheckoutButton.classList.remove('checkout_hide');
        }
      }
    });
  };
}
loadTogglestate()


function loadVIPtoggle() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let hasProduct1 = false;
      let hasProduct2 = false;
      let hasMlab = false;
      let hasVip = false;          
      cart.items.forEach(item => {
        if (item.product_id === productIds[0]) {
          hasProduct1 = true;
        }
        if (item.product_id === productIds[1]) {
          hasProduct2 = true;
        }
        if (item.product_id === vipIds[0] || item.product_id === vipIds[1] || item.product_id === vipIds[2] ) {
          hasVip = true;
          sessionStorage.setItem('vipatcClose', 'true');
        }
      });

      const viptoggle = document.getElementById('perk_cart_toggle');
      const checkoutButton = document.getElementById('CartDrawer-Checkout');
      const vipcheckoutButton = document.getElementById('Cart-Drawer-VIP-Checkout');  
      const checkboxKey = 'myCheckboxState';

    if (viptoggle) {
      if (hasProduct1 || hasProduct2 ) {
        if (hasVip) {
          sessionStorage.removeItem('myCheckboxState');
        };
        viptoggle.addEventListener('change', () => {
          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));         
          if (viptoggle.checked) {      
              //console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')           
            } else {
              //console.log("Opting Out - No VIP Offer");
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };         
        });  
      } else if (hasVip) {
        //console.log("VIP in cart");
        sessionStorage.removeItem('myCheckboxState');    
        
      } else { 
        viptoggle.addEventListener('change', () => {

          sessionStorage.setItem(checkboxKey, JSON.stringify(viptoggle.checked));       
          if (viptoggle.checked) {      
              //console.log("Opting In - ADD VIP To Cart");
              checkoutButton.classList.add('checkout_hide')
              vipcheckoutButton.classList.remove('checkout_hide')
              //regsubtotal.classList.add('checkout_hide')
              //vipsubtotal.classList.remove('checkout_hide')         
            } else {
              //console.log("Opting Out - No VIP Offer");
              //regsubtotal.classList.remove('checkout_hide')
              //vipsubtotal.classList.add('checkout_hide')
              checkoutButton.classList.remove('checkout_hide')
              vipcheckoutButton.classList.add('checkout_hide')
           };
          
        });                                                                                             
      }
    }
  })
  .catch(error => {      
  });
} 


//function to check for specific discount
function hasSpecificDiscount(lineItem, discountCode) {
  if (lineItem.discounts && lineItem.discounts.length > 0) {
    for (const discount of lineItem.discounts) {
      if (discount.code && discount.code.toLowerCase() === discountCode.toLowerCase()) {
        return true;
      }
    }
  }
  return false;
}

  //const productIds = [2043719581766, 6764342542439, 14620006646123, 14629727207787, 14624407224683 ,14649752355179, 14650219954539, 14662529941867];
  //Product 1 - Regular Kit
  //Product 2 - Deluxe Kit
  //const hasFREEVip - VIP one month Free
  //const vipIds = [6763916230759, 14662529941867, 14676068565355];
  //const pinnedUpsells = [14701367722347]; = [0]-Daily Essentials Routine - 35% Off

  function checkCartProducts() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {

        if (cart && Array.isArray(cart.items) && cart.items.length === 0) {
          console.log('Cart is empty');
          sessionStorage.removeItem('myCheckboxState');
          fetch("/discount/CLEAR");
          
        };
        
        let hasProduct1 = false;
        let hasProduct2 = false;
        let hasFREEVip = false;
        let haspinnedUpsells = false;
        let hasNew25gwpOne = false;
        let hasNew25gwpTwo = false;
        let hasNEW25applied = false;

        cart.items.forEach(item => {
          if (item.product_id === productIds[0]) {
            hasProduct1 = true;
            //console.log('Discovery In Cart');          
          }
          if (item.product_id === productIds[1]) {
            hasProduct2 = true;
            //console.log('Deluxe In Cart');   
          }
         if (item.product_id === freeVipId[0]) {
            hasFREEVip = true;
            //console.log('VIP One Month Free in cart');
          }
          if (item.product_id === pinnedUpsells[0] ) {
            haspinnedUpsells = true;
            //console.log('Pinned Upsell In Cart');
          }  
          if (item.product_id === 14710272000363 ) {
            hasNew25gwpOne = true;
            //console.log('New25 GWP Deluxe Kit In Cart');
            document.querySelector(`.cart-item[data-id="52073836740971"] cart-remove-button`).click(); 
          }
         if (item.product_id === 14710274523499 ) {
            hasNew25gwpTwo = true;
            //console.log('New25 GWP Light Show In Cart');
            document.querySelector(`.cart-item[data-id="52073845686635"] cart-remove-button`).click(); 
          }
          
          //Check logging each item and if and what discount code they have
          if (item.discounts && item.discounts.length > 0) {
          //console.log(`Discount applied to item ${item.product_title}:`, item.discounts);
          item.discounts.forEach(discount => {
              //if Discount NEW25
              if (discount.title === 'NEW25') {
                hasNEW25applied = true;
                //console.log('New25 applied to ITEM in cart');
              }
              //Logging all discounts
              //console.log(`Discount title: ${discount.title}, amount: ${discount.amount}, type: ${discount.type}`)
            })
          }
          
        });

        // Get the button element
        const kitButton = document.querySelector('.kit-button');
        // Check if the element exists before proceeding
        if (kitButton) {
          if (hasProduct1 || hasProduct2 || hasNEW25applied ) {
            kitButton.classList.add('discovery-hasin-cart');
            kitButton.disabled = true;
          } else {
              kitButton.classList.remove('discovery-hasin-cart');
              kitButton.disabled = false;
          }
        }

        if (hasNEW25applied ) {
                   
              checkCartTotal().then(cartInfo => {
                    //Gift1
                    //add product gift
                    if(cartInfo.totalPrice >= giftProduct_7_price[0] && !cartInfo.productLists.includes(giftProductVariant_7_id[0])) {
                      console.log('simple gift after '+giftProduct_7_price[0]+' tor on green')                   
                      document.querySelector(`#gift-product-${giftProductVariant_7_id[0]} button[name="add"]`).click();
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_7_price[0] && cartInfo.productLists.includes(giftProductVariant_7_id[0])) {
                      console.log('Simple Gift Remove')
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_7_id[0]}"] cart-remove-button`).click();
                    }
                    //Gift2
                    //add product gift
                    //Added Preliminary IF statement to wait for first gift to be added if not already added.
                    if(cartInfo.productLists.includes(giftProductVariant_7_id[0])) {
                      if(cartInfo.totalPrice >= giftProduct_8_price[0] && !cartInfo.productLists.includes(giftProductVariant_8_id[0])) {
                        console.log('simple gift after '+giftProduct_8_price[0]+' tor on')                 
                        document.querySelector(`#gift-product-${giftProductVariant_8_id[0]} button[name="add"]`).click();
                      }
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_8_price[0] && cartInfo.productLists.includes(giftProductVariant_8_id[0])) {
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_8_id[0]}"] cart-remove-button`).click();
                    }
                    //Gift3
                    //add product gift
                    //Added Preliminary IF statement to wait for first gift to be added if not already added.
                    if(cartInfo.productLists.includes(giftProductVariant_8_id[0])) {
                      if(cartInfo.totalPrice >= giftProduct_8b_price[0] && !cartInfo.productLists.includes(giftProductVariant_8b_id[0])) {
                        console.log('simple gift after '+giftProduct_8b_price[0]+' tor on')                 
                        document.querySelector(`#gift-product-${giftProductVariant_8b_id[0]} button[name="add"]`).click();
                      }
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_8b_price[0] && cartInfo.productLists.includes(giftProductVariant_8b_id[0])) {
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_8b_id[0]}"] cart-remove-button`).click();
                    }
                    
                });

                const kitAtc = document.getElementById('showPU');
                 if (kitAtc) {
                  document.querySelector(`.kit-pu-cta`).innerHTML = "Unavailable - New Customer Offers cannot be combined.";
                  document.querySelector(`.kit-pu-cta`).classList.add('new25-cart');
                  document.querySelector(`.pp_addon-popup-product-page`).style.visibility = 'hidden';
                }
              
                if( hasProduct1 ){
                  document.querySelector(`.cart-item[data-id="20633669795910"] cart-remove-button`).click(); 
                } else if( hasProduct2 ){
                  document.querySelector(`.cart-item[data-id="40102681509991"] cart-remove-button`).click(); 
                } else if (haspinnedUpsells) {
                  document.querySelector(`.cart-item[data-id="52029570842987"] cart-remove-button`).click(); 
                }
              
                //Load VIP toggle
                loadVIPtoggle()

  
          } else if (hasProduct1 ) { 
                 
            checkCartTotal().then(cartInfo => {
        
                    //Gift1
                    //add product gift
                    if(cartInfo.totalPrice >= giftProduct_1_price[0] && !cartInfo.productLists.includes(giftProductVariant_1_id[0])) {
                      console.log('simple gift after '+giftProduct_1_price[0]+' tor on green')                   
                      document.querySelector(`#gift-product-${giftProductVariant_1_id[0]} button[name="add"]`).click();
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_1_price[0] && cartInfo.productLists.includes(giftProductVariant_1_id[0])) {
                      console.log('Simple Gift Remove')
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                    }
                    //Gift2
                    //add product gift
                    //Added Preliminary IF statement to wait for first gift to be added if not already added.
                    if(cartInfo.productLists.includes(giftProductVariant_1_id[0])) {
                      if(cartInfo.totalPrice >= giftProduct_2_price[0] && !cartInfo.productLists.includes(giftProductVariant_2_id[0])) {
                        console.log('simple gift after '+giftProduct_2_price[0]+' tor on')                 
                        document.querySelector(`#gift-product-${giftProductVariant_2_id[0]} button[name="add"]`).click();
                      }
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_2_price[0] && cartInfo.productLists.includes(giftProductVariant_2_id[0])) {
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                    }
                    //Gift3
                    //add product gift
                    //Added Preliminary IF statement to wait for first gift to be added if not already added.
                    if(cartInfo.productLists.includes(giftProductVariant_2_id[0])) {
                      if(cartInfo.totalPrice >= giftProduct_2b_price[0] && !cartInfo.productLists.includes(giftProductVariant_2b_id[0])) {
                        console.log('simple gift after '+giftProduct_2b_price[0]+' tor on')                 
                        document.querySelector(`#gift-product-${giftProductVariant_2b_id[0]} button[name="add"]`).click();
                      }
                    }
                    //remove
                    if(cartInfo.totalPrice < giftProduct_2b_price[0] && cartInfo.productLists.includes(giftProductVariant_2b_id[0])) {
                      document.querySelector(`.cart-item[data-id="${giftProductVariant_2b_id[0]}"] cart-remove-button`).click();
                    }

              });
        
              //Load VIP toggle
              loadVIPtoggle()


        } else if (hasProduct2) {  
            
           checkCartTotal().then(cartInfo => {

                  //Gift1
                  //add product gift
                  if(cartInfo.totalPrice >= giftProduct_3_price[0] && !cartInfo.productLists.includes(giftProductVariant_3_id[0])) {
                    console.log('simple gift after '+giftProduct_3_price[0]+' tor on')                 
                    document.querySelector(`#gift-product-${giftProductVariant_3_id[0]} button[name="add"]`).click();
                  }
                  //remove
                  if(cartInfo.totalPrice < giftProduct_3_price[0] && cartInfo.productLists.includes(giftProductVariant_3_id[0])) {
                    document.querySelector(`.cart-item[data-id="${giftProductVariant_3_id[0]}"] cart-remove-button`).click();
                  }
                  //Gift2
                  //add product gift
                  //Added Preliminary IF statement to wait for first gift to be added if not already added.
                  if(cartInfo.productLists.includes(giftProductVariant_3_id[0])) {
                    if(cartInfo.totalPrice >= giftProduct_4_price[0] && !cartInfo.productLists.includes(giftProductVariant_4_id[0])) {
                      console.log('simple gift after '+giftProduct_4_price[0]+' tor on')                
                      document.querySelector(`#gift-product-${giftProductVariant_4_id[0]} button[name="add"]`).click();
                    }
                  }
                  //remove
                  if(cartInfo.totalPrice < giftProduct_4_price[0] && cartInfo.productLists.includes(giftProductVariant_4_id[0])) {
                    document.querySelector(`.cart-item[data-id="${giftProductVariant_4_id[0]}"] cart-remove-button`).click();
                  }
                  //Gift3
                  //add product gift
                  //Added Preliminary IF statement to wait for first gift to be added if not already added.
                  if(cartInfo.productLists.includes(giftProductVariant_4_id[0])) {
                    if(cartInfo.totalPrice >= giftProduct_4b_price[0] && !cartInfo.productLists.includes(giftProductVariant_4b_id[0])) {
                      console.log('simple gift after '+giftProduct_4b_price[0]+' tor on')                
                      document.querySelector(`#gift-product-${giftProductVariant_4b_id[0]} button[name="add"]`).click();
                    }
                  }
                  //remove
                  if(cartInfo.totalPrice < giftProduct_4b_price[0] && cartInfo.productLists.includes(giftProductVariant_4b_id[0])) {
                    document.querySelector(`.cart-item[data-id="${giftProductVariant_4b_id[0]}"] cart-remove-button`).click();
                  }
             
              });
            
              //Load VIP toggle
              loadVIPtoggle()

        } else if (haspinnedUpsells) { 

            //remove Pinned Upsell if kit not in cart
            if (hasProduct1 || hasProduct2 == false) {
                document.querySelector(`.cart-item[data-id="52029570842987"] cart-remove-button`).click(); 
            }
   
        } else {
              
         checkCartTotal().then(cartInfo => {

              /******* Free Gift 1 *******/
              /**Part 1 - Remove other Gifts**/

              /** All products are currently the same for BF so commenting out duplicates for now - Nicole 5/14/25
               
              if(cartInfo.productLists.includes(giftProductVariant_1_id[0]) && giftProductVariant_1_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_1_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_2_id[0]) && giftProductVariant_2_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_2_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_2b_id[0]) && giftProductVariant_2b_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_2b_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_2b_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_3_id[0]) && giftProductVariant_3_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_3_id[0]}"] cart-remove-button`).click();
                console.log('remove 3 gift'+giftProductVariant_3_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_4_id[0]) && giftProductVariant_4_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_4_id[0]}"] cart-remove-button`).click();
                console.log('remove 4 gift'+giftProductVariant_4_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_4b_id[0]) && giftProductVariant_4b_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_4b_id[0]}"] cart-remove-button`).click();
                console.log('remove 4 gift'+giftProductVariant_4b_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_5_id[0]) && giftProductVariant_5_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_5_id[0]}"] cart-remove-button`).click();
                console.log('remove 5 gift'+giftProductVariant_5_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_6_id[0]) && giftProductVariant_6_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_6_id[0]}"] cart-remove-button`).click();
                console.log('remove 6 gift'+giftProductVariant_6_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_6b_id[0]) && giftProductVariant_6b_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_6b_id[0]}"] cart-remove-button`).click();
                console.log('remove 6 gift'+giftProductVariant_6b_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_7_id[0]) && giftProductVariant_7_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_7_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_7_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_8_id[0]) && giftProductVariant_8_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_8_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_8_id[0])
              }
              /** All products are currently the same so commenting out duplicates for now - Nicole 5/14/25
              if(cartInfo.productLists.includes(giftProductVariant_8b_id[0]) && giftProductVariant_8b_id[0] != free_gift_sitewide1_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_8b_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_8b_id[0])
              }
              **/

              if (hasProduct1 || hasProduct2 == false) {
                /**Part 2 - add Free Gift 1**/
                if(cartInfo.totalPrice >= free_gift_sitewide1_price_1[0] && !cartInfo.productLists.includes(free_gift_sitewide1_variant_id_1[0])) {
                  console.log('simple gift after '+free_gift_sitewide1_price_1[0]+' tor on')
                  console.log(document.querySelector(`#gift-product-${free_gift_sitewide1_variant_id_1[0]} button[name="add"]`))
                  document.querySelector(`#gift-product-${free_gift_sitewide1_variant_id_1[0]} button[name="add"]`).click();
                }
                //remove
                if(cartInfo.totalPrice < free_gift_sitewide1_price_1[0] && cartInfo.productLists.includes(free_gift_sitewide1_variant_id_1[0])) {
                  document.querySelector(`.cart-item[data-id="${free_gift_sitewide1_variant_id_1[0]}"] cart-remove-button`).click();
                }
              }

              /******* Free Gift 2 *******/
              /**Part 1 - Remove other Gifts**/

              /** All products are currently the same for BF so commenting out duplicates for now - Nicole 5/14/25
              if(cartInfo.productLists.includes(giftProductVariant_1_id[0]) && giftProductVariant_1_id[0] != free_gift_sitewide2_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_1_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_2_id[0]) && giftProductVariant_2_id[0] != free_gift_sitewide2_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_2_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_7_id[0]) && giftProductVariant_7_id[0] != free_gift_sitewide2_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_7_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_7_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_8_id[0]) && giftProductVariant_8_id[0] != free_gift_sitewide2_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_8_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_8_id[0])
              }
              **/

              /**Part 2 - add Free Gift 2**/
              if(cartInfo.totalPrice >= free_gift_sitewide2_price_1[0] && !cartInfo.productLists.includes(free_gift_sitewide2_variant_id_1[0])) {
                console.log('simple gift after '+free_gift_sitewide2_price_1[0]+' tor on')
                console.log(document.querySelector(`#gift-product-${free_gift_sitewide2_variant_id_1[0]} button[name="add"]`))
                document.querySelector(`#gift-product-${free_gift_sitewide2_variant_id_1[0]} button[name="add"]`).click();
              }
              //remove
              if(cartInfo.totalPrice < free_gift_sitewide2_price_1[0] && cartInfo.productLists.includes(free_gift_sitewide2_variant_id_1[0])) {
                document.querySelector(`.cart-item[data-id="${free_gift_sitewide2_variant_id_1[0]}"] cart-remove-button`).click();
              }

              /******* Free Gift 3 *******/
              /**Part 1 - Remove other Gifts**/
              /** All products are currently the same for BF so commenting out duplicates for now - Nicole 5/14/25
              if(cartInfo.productLists.includes(giftProductVariant_1_id[0]) && giftProductVariant_1_id[0] != free_gift_sitewide3_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_1_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_1_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_2_id[0]) && giftProductVariant_2_id[0] != free_gift_sitewide3_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_2_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_2_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_7_id[0]) && giftProductVariant_7_id[0] != free_gift_sitewide3_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_7_id[0]}"] cart-remove-button`).click();
                console.log('remove first gift'+giftProductVariant_7_id[0])
              }
              if(cartInfo.productLists.includes(giftProductVariant_8_id[0]) && giftProductVariant_8_id[0] != free_gift_sitewide3_variant_id_1[0]) {
                document.querySelector(`.cart-item[data-id="${giftProductVariant_8_id[0]}"] cart-remove-button`).click();
                console.log('remove second gift'+giftProductVariant_8_id[0])
              }
              **/
             
              /**Part 2 - add Free Gift 3**/
              if(cartInfo.totalPrice >= free_gift_sitewide3_price_1[0] && !cartInfo.productLists.includes(free_gift_sitewide3_variant_id_1[0])) {
                console.log('simple gift after '+free_gift_sitewide3_price_1[0]+' tor on')
                console.log(document.querySelector(`#gift-product-${free_gift_sitewide3_variant_id_1[0]} button[name="add"]`))
                document.querySelector(`#gift-product-${free_gift_sitewide3_variant_id_1[0]} button[name="add"]`).click();
              }
              //remove
              if(cartInfo.totalPrice < free_gift_sitewide3_price_1[0] && cartInfo.productLists.includes(free_gift_sitewide3_variant_id_1[0])) {
                document.querySelector(`.cart-item[data-id="${free_gift_sitewide3_variant_id_1[0]}"] cart-remove-button`).click();
              }

          }); 

            //Load VIP toggle
            loadVIPtoggle()  
          
            //remove VIP one month free if no kit in cart
            if (hasProduct1 || hasProduct2 == false) {
              if (hasFREEVip == true) {
                document.querySelector(`.cart-item[data-id="51814900728171"] cart-remove-button`).click();      
              }
            }
            
            //change button name in pdp Discovery Kit
            /**if (hasProduct3 || hasProduct5 || hasProduct6 || hasProduct7) { 
              document.querySelector(`#showPU[data-id="2043719581766"]`).classList.add('discovery-hasin-cart');
              document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = true;             
            } else {
               if (isThisProductPage()) {
                  document.querySelector(`#showPU[data-id="2043719581766"]`).classList.remove('discovery-hasin-cart');
                  document.querySelector(`#showPU[data-id="2043719581766"]`).disabled = false;
               }
            }**/

        }
      })
      .catch(error => {
        
      });
  } 


//checking if this product page true or false
function isThisProductPage() {
  const analyticsScript = document.getElementById('shop-js-analytics');

  if (analyticsScript) {
    const analyticsData = JSON.parse(analyticsScript.textContent);

    if (analyticsData.pageType === 'product') {
      return true;
    }
  }

  return false;
}

//**Make sure cart products are rechecked on page load**/
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    // Code to run when page is restored from bfcache
    //console.log('Page restored from bfcache');
    checkCartProducts()
    // Re-execute your JavaScript code here
  } else {
   // Code to run on initial page load
    //console.log('Page loaded normally');
    checkCartProducts();
  }
  // Call the new timer function
  startOrUpdateCartTimer();
});
